import { useLang } from 'hooks/lang';

import { Column, Alert, Button } from 'components/Blocks';

import { useTaskModal } from './context.taskModal';
import { useTaskOption } from '../TaskOptions';

export function TaskAlerts() {
  const { t } = useLang();
  const { loading, task } = useTaskModal();

  const answerDateReq = useTaskOption('ANSWER_DATE_CHANGE', task.id);

  if (loading || !answerDateReq.isEnabled) return null;

  return (
    <Column className="animate-in slide-in-from-bottom-12" alignItems="center">
      <Alert level="warning" bodyClassName="flex gap-2 items-center">
        {t('theres-an-active-request-to-change-this-expected-date')}

        <Button
          className="ml-auto"
          color="warning"
          variant="ghost"
          size="small"
          onClick={answerDateReq.action}
        >
          {t('review')}
        </Button>
      </Alert>
    </Column>
  );
}
